module.exports = __webpack_public_path__ + "img/slide-objectview_inactive.1e366a05.svg";